// extracted by mini-css-extract-plugin
export default {"brandPromo":"kF-z","carousel":"lF-z"};